import { Box, Button, Icon, Typography } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

/* eslint-disable react/prop-types */
const CardInforDoc = ({ title, number, onDetail, bgColor, icon, color }) => {
  const handleToDetail = () => {
    onDetail?.();
  };
  return (
    <Box
      display={"flex"}
      gap={1}
      boxShadow={
        "0rem 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.1),0rem 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.06)"
      }
      padding={"1rem"}
      borderRadius={"0.5rem"}
      sx={{
        backgroundColor: bgColor,
        height: "100%",
      }}
    >
      <Box display={"flex"} flexDirection={"column"} flexGrow={1}>
        <Typography variant="h6" sx={{ fontWeight: "600", fontSize: "1rem" }}>
          {title}
        </Typography>
        <Typography variant="h5" fontSize={"1.75rem"}>
          {number}
        </Typography>
        <MDButton
          onClick={handleToDetail}
          endIcon={<EastIcon />}
          sx={{
            color: "#ffffff",
            maxWidth: "10rem",
            marginTop: "0.5rem",
            fontSize: "0.75rem",
          }}
          color={color}
          size="small"
          variant="gradient"
        >
          Xem chi tiết
        </MDButton>
      </Box>
      <MDBox
        display="grid"
        justifyContent="center"
        alignItems="center"
        color="white"
        width="2.5rem"
        height="2.5rem"
        shadow="md"
        borderRadius="lg"
        variant="gradient"
        bgColor={color}
        style={{
          margin: "auto",
        }}
      >
        <Icon fontSize="medium">{icon}</Icon>
      </MDBox>
    </Box>
  );
};
export default CardInforDoc;
